module.exports = __webpack_public_path__ + "static/media/peer_image1.1732c42c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer_image1.png
// module id = 2648
// module chunks = 0